import { useEffect, useState } from "react";

/**
 * Число у пункта «Что нового»: сколько записей появилось с тех пор, как человек
 * читал список.
 *
 * ⚠️ **Ни одного запроса к серверу.** Записи лежат в бандле, а указатель
 * «докуда дочитал» приезжает в `MeResponse` из уже прочитанной строки
 * `app_user`. То есть счётчик стоит ноль запросов у всех, включая ученика:
 * спрашивать нечего, потому что спрашивать некого.
 *
 * ⚠️ **Ученику не уезжает даже чанк.** При `enabled === false` динамического
 * импорта не происходит вовсе, то есть файл записей на его канал не попадает
 * (раздел 5.1 CLAUDE.md: чанкование держится исключительно на `import()`).
 * Условие «сторона преподавателя» считается в `Shell` через `isTeacherSide` и
 * приезжает сюда параметром, а не ветвлением вокруг вызова: состав хуков обязан
 * совпадать от рендера к рендеру.
 *
 * ⚠️ **Это не транспорт уведомлений и раздела 4 CLAUDE.md не касается.**
 * Наружу не уходит ничего: число показывается тому, кто уже открыл кабинет.
 * Запрет там на доставку критичного через чужие мессенджеры, а не на подпись в
 * собственном интерфейсе (тот же довод в шапке `HomeworkNews.tsx`).
 */
export function useChangelogNews(enabled: boolean, seenAt: number | null | undefined): number {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!enabled || seenAt === null || seenAt === undefined) {
      setCount(0);
      return;
    }
    let alive = true;
    void (async () => {
      try {
        const [{ CHANGELOG }, { countNew }] = await Promise.all([
          import("../changelog/entries.ts"),
          import("../changelog/select.ts"),
        ]);
        if (alive) setCount(countNew(CHANGELOG, seenAt));
      } catch {
        // Значок это справка, а не работа человека: отказ загрузки чанка гасит
        // число и молчит. Тот же довод, что у полоски хранилища в сайдбаре
        if (alive) setCount(0);
      }
    })();
    return () => {
      alive = false;
    };
  }, [enabled, seenAt]);

  return count;
}
